/**
 * Loads the marketing type stack on demand.
 *
 * Space Grotesk / JetBrains Mono / Manrope used to sit in `index.html`, which
 * meant every signed-in dashboard session downloaded three families it never
 * renders — scoping the *theme* to the public routes does nothing about the
 * *download*. `PublicLayout` calls this on mount instead, so the faces are
 * fetched only when a public page is actually being shown.
 *
 * Idempotent: the tags are appended once per document and left in place, so
 * navigating between public pages does not refetch.
 */
const STYLESHEET_ID = 'motzu-marketing-fonts';

const HREF =
  'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700;800' +
  '&family=JetBrains+Mono:wght@400;500;700' +
  '&family=Manrope:wght@400;500;600;700;800&display=swap';

export const loadMarketingFonts = (): void => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLESHEET_ID)) return;

  // `index.html` already preconnects to both font hosts for the app's own
  // Inter, so only the stylesheet itself is added here.
  const link = document.createElement('link');
  link.id = STYLESHEET_ID;
  link.rel = 'stylesheet';
  link.href = HREF;
  document.head.appendChild(link);
};
